"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9643],{

/***/ 9643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SectionCaseStudyDetails": function() { return /* binding */ SectionCaseStudyDetails; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(79570);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(16405);
// EXTERNAL MODULE: ../../libs/styles/src/index.ts + 15 modules
var src = __webpack_require__(55022);
// EXTERNAL MODULE: ../../libs/components/src/index.ts + 122 modules
var components_src = __webpack_require__(75762);
// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/index.js + 14 modules
var es = __webpack_require__(61349);
// EXTERNAL MODULE: ../../libs/icons/src/index.ts + 18 modules
var icons_src = __webpack_require__(46115);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionCaseStudyDetails/TechStackModal.tsx





const StyledModalContent = (0,src/* styled */.zo)("div", {
    padding: "$16 $20 $24",
    backgroundColor: "$white",
    zIndex: "$content",
    "@md": {
        padding: "$32 $40 $40",
        borderRadius: "$r3",
        margin: "$72 0",
        maxWidth: "$techStackModalWidth"
    }
});
const StyledHeaderWrapper = (0,src/* styled */.zo)("div", {
    position: "sticky",
    top: "0",
    backgroundColor: "$white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "$8 0",
    marginBottom: "$32",
    zIndex: "$content",
    "@md": {
        marginBottom: "$48",
        position: "unset"
    }
});
const StyledTitle = (0,src/* styled */.zo)("h2", {
    projectFont: "heading08"
});
const StyledButton = (0,src/* styled */.zo)(components_src/* Button */.zx, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "$40",
    height: "$40",
    borderRadius: "$rMax",
    background: "$black_005",
    transition: "0.2s background",
    "@md": {
        "&:hover": {
            background: "$black_01"
        }
    },
    "&:focus-visible": {
        outline: "$focusBlue solid 3px;"
    },
    "&:disabled": {
        display: "none"
    }
});
const StyledTechStackWrapper = (0,src/* styled */.zo)("div", {
    "& > div": {
        padding: "$12 0 $20",
        borderBottom: "1px solid $gray500_01",
        "@md": {
            padding: "$16 0 $24"
        }
    },
    "& > div:first-child": {
        borderTop: "1px solid $gray500_01"
    }
});
const StyledTechStack = (0,src/* styled */.zo)("div", {
    display: "grid",
    gap: "$12",
    "@md": {
        gap: "$4",
        gridTemplateColumns: "1.1fr 1fr"
    }
});
const StyledType = (0,src/* styled */.zo)("p", {
    projectFont: "ui03",
    textTransform: "uppercase",
    marginBottom: "$16",
    "@md": {
        marginBottom: "$20"
    }
});
const StyledDescription = (0,src/* styled */.zo)("p", {
    projectFont: "body04",
    minHeight: "$techStackModalTextHeight"
});
const IconWrap = (0,src/* styled */.zo)("div", {
    width: "80px"
});
const TechStackModal = (param)=>{
    let { closeModal , techStack  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                        children: "Tech stack"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        onClick: closeModal,
                        "aria-label": "close",
                        appearance: "grid",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src/* Close */.x8, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTechStackWrapper, {
                children: techStack === null || techStack === void 0 ? void 0 : techStack.map((tech, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledType, {
                                children: tech.type
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTechStack, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrap, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Media */.pU, {
                                            ...tech.logo,
                                            layout: "responsive",
                                            sizes: "80px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescription, {
                                        children: tech.shortDescription
                                    })
                                ]
                            })
                        ]
                    }, "".concat(index, "-").concat(tech.name)))
            })
        ]
    });
};
/* harmony default export */ var SectionCaseStudyDetails_TechStackModal = (TechStackModal);

// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionQuote/SectionQuote.tsx
var SectionQuote = __webpack_require__(14618);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionIconWithTextList/SectionIconWithTextList.tsx
var SectionIconWithTextList = __webpack_require__(89274);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionSingleMediaWithDescription/SectionSingleMediaWithDescription.tsx
var SectionSingleMediaWithDescription = __webpack_require__(79689);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionVideoPlayer/SectionVideoPlayer.tsx
var SectionVideoPlayer = __webpack_require__(96811);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionQuoteWithVideo/SectionQuoteWithVideo.tsx
var SectionQuoteWithVideo = __webpack_require__(56390);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionStats/SectionStats.tsx
var SectionStats = __webpack_require__(49197);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionCaseStudyDetails/SectionCaseStudyDetails.tsx













const StyledSectionWrapper = (0,src/* styled */.zo)(components_src/* SectionWrapper */.Uq, {
    display: "grid",
    gap: "$72",
    marginTop: "$56",
    marginBottom: "$56",
    "@lg": {
        gap: "unset",
        gridTemplateColumns: "1fr 2fr .25fr",
        marginTop: "$144",
        marginBottom: "$144"
    }
});
const StyledDetailsWrapper = (0,src/* styled */.zo)(components_src/* Container */.W2, {
    maxWidth: "$aboutPageLeftColumnMaxWidth",
    "@lg": {
        gridColumn: "1/2"
    },
    "> div:not(:last-child)": {
        marginBottom: "$40"
    }
});
const StyledIntroductionWrapper = (0,src/* styled */.zo)(components_src/* Container */.W2, {
    projectFont: "body01",
    h2: {
        projectFont: "heading07"
    },
    "@lg": {
        gridColumn: "2/span 1",
        maxWidth: "$richTextWidth"
    }
});
const StyledDetailsTitle = (0,src/* styled */.zo)("h2", {
    projectFont: "ui03",
    textTransform: "uppercase"
});
const StyledDetailsText = (0,src/* styled */.zo)("p", {
    projectFont: "body02",
    display: "inline-block"
});
const StyledIcon = (0,src/* styled */.zo)("span", {
    paddingLeft: "$4"
});
const StyledOpenModalButton = (0,src/* styled */.zo)(components_src/* Button */.zx, {
    projectFont: "body02",
    textDecoration: "underline",
    textUnderlineOffset: "5px",
    textDecorationThickness: "1px"
});
const SectionCaseStudyDetails = (param)=>{
    let { introduction , techStack , design , url  } = param;
    const [isTechStackModalOpen, setTechStackModalOpen] = (0,react.useState)(false);
    const isMd = (0,src/* useMediaQuery */.ac)("md");
    const { t  } = (0,es/* useTranslation */.$G)("caseStudy");
    const closeTechStackModal = ()=>{
        setTechStackModalOpen(false);
    };
    const openTechStackModal = ()=>{
        setTechStackModalOpen(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSectionWrapper, {
        type: "NO_MARGIN",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDetailsWrapper, {
                children: [
                    url && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDetailsTitle, {
                                children: t("liveSite")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_src/* Link */.rU, {
                                href: url,
                                target: "_blank",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDetailsText, {
                                        children: [
                                            url,
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src/* OpenNewTab */.mw, {
                                            fill: "black"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    design && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDetailsTitle, {
                                children: t("digitalDesign")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDetailsText, {
                                children: design
                            })
                        ]
                    }),
                    techStack && techStack.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDetailsTitle, {
                                        children: t("techStack")
                                    }),
                                    techStack.map((tech, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDetailsText, {
                                            children: [
                                                tech.name,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: ",\xa0"
                                                })
                                            ]
                                        }, "".concat(index, "-").concat(tech.name))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOpenModalButton, {
                                        onClick: openTechStackModal,
                                        children: t("more")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Modal */.u_, {
                                preventScroll: true,
                                isOpen: isTechStackModalOpen,
                                size: isMd ? "intrinsic" : "stretch",
                                variant: isMd ? "rounded" : "default",
                                onRequestClose: closeTechStackModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionCaseStudyDetails_TechStackModal, {
                                    closeModal: closeTechStackModal,
                                    techStack: techStack
                                })
                            })
                        ]
                    })
                ]
            }),
            introduction && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntroductionWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* PortableText */.YI, {
                    value: introduction,
                    // this section has explicit top and bottom margins so we disable them on PortableText. Section is display: grid, so margin collapsing doesn't work anyway.
                    disableTopBottomMargins: true,
                    additionalComponents: {
                        types: {
                            sectionQuote: (props)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionQuote.SectionQuote, {
                                    ...props.value
                                });
                            },
                            sectionIconWithTextList: (props)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionIconWithTextList/* SectionIconWithTextList */.Z, {
                                    ...props.value
                                });
                            },
                            sectionSingleMediaWithDescription: (props)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionSingleMediaWithDescription.SectionSingleMediaWithDescription, {
                                    ...props.value
                                });
                            },
                            sectionVideoPlayer: (props)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionVideoPlayer/* SectionVideoPlayer */.b, {
                                    ...props.value
                                });
                            },
                            sectionQuoteWithVideo: (props)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionQuoteWithVideo/* SectionQuoteWithVideo */.s, {
                                    ...props.value
                                });
                            },
                            sectionStats: (props)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionStats/* SectionStats */.d, {
                                    ...props.value
                                });
                            }
                        }
                    }
                })
            })
        ]
    });
};


/***/ }),

/***/ 56390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ SectionQuoteWithVideo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16405);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30299);
/* harmony import */ var _SectionVideoTestimonials_VideoTestimonial__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78432);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75762);






const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_4__/* .SectionWrapper */ .Uq, {
    gap: "$32",
    display: "grid",
    "@xl": {
        gridTemplateColumns: "340px 1fr"
    },
    borderRadius: "$r3_mobile",
    "@lg": {
        borderRadius: "$r3"
    }
});
const Quote = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "heading06",
    marginTop: 0
});
const SectionQuoteWithVideo = (param)=>{
    let { quote , media , personName , personPosition , logo , textColor , backgroundColor , priority  } = param;
    const isMd = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .ac)("md");
    const [isVideoPlaying, setIsVideoPlaying] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // when the view shifts between mobile and desktop, we want to pause videos to prevent double play
        setIsVideoPlaying(false);
    }, [
        isMd
    ]);
    const handleSlidePlayPause = ()=>setIsVideoPlaying((prevState)=>!prevState);
    const handleOnEnded = ()=>{
        setIsVideoPlaying(false);
    };
    const handleSlideIntersectionChange = (inView)=>{
        if (!inView) {
            setIsVideoPlaying(false);
        }
    };
    const resolvedTextColor = (textColor === null || textColor === void 0 ? void 0 : textColor.rgba) || (textColor === null || textColor === void 0 ? void 0 : textColor.hex);
    const resolvedBackgroundColor = (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.rgba) || (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.hex);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: "RICH_TEXT_SM",
        css: resolvedBackgroundColor ? {
            backgroundColor: resolvedBackgroundColor
        } : undefined,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__/* .InView */ .df, {
                threshold: 0.6,
                onChange: handleSlideIntersectionChange,
                children: (param)=>/*#__PURE__*/ {
                    let { inView , ref  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionVideoTestimonials_VideoTestimonial__WEBPACK_IMPORTED_MODULE_3__/* .VideoTestimonial */ .N, {
                        ref: ref,
                        media: media,
                        personName: personName,
                        personPosition: personPosition,
                        logo: logo,
                        priority: priority,
                        play: isVideoPlaying,
                        canHideControlsForVideo: isVideoPlaying,
                        inView: inView,
                        handleOnEnded: handleOnEnded,
                        handleSlidePlayPause: handleSlidePlayPause
                    });
                }
            }),
            quote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Quote, {
                    css: resolvedTextColor ? {
                        color: resolvedTextColor
                    } : undefined,
                    children: quote
                })
            })
        ]
    });
};


/***/ }),

/***/ 49197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ SectionStats; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const StatsWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    rowGap: "$32",
    columnGap: "$32",
    "@md": {
        gridTemplateColumns: "1fr 1fr",
        rowGap: "$72"
    }
});
const Stat = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    gap: "$16",
    "@md": {
        gap: "$24"
    }
});
const ValueWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "flex"
});
const Value = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("span", {
    projectFont: "numbers01"
});
const Symbol = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("span", {
    projectFont: "display02",
    lin: {
        fontSize: [
            30,
            48
        ]
    },
    paddingTop: "$4"
});
const Label = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "body03"
});
const SectionStats = (param)=>{
    let { stats  } = param;
    if (!stats || stats.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
        type: "RICH_TEXT_MD",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StatsWrap, {
            children: stats.map((param, index)=>/*#__PURE__*/ {
                let { label , value , symbol  } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Stat, {
                    children: [
                        value && symbol && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ValueWrap, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Value, {
                                    children: value
                                }),
                                symbol !== "none" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Symbol, {
                                    children: symbol
                                })
                            ]
                        }),
                        label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                            style: {
                                marginTop: 0
                            },
                            children: label
                        })
                    ]
                }, "".concat(index, "-").concat(label));
            })
        })
    });
};


/***/ }),

/***/ 96811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SectionVideoPlayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
    display: "grid",
    rowGap: "$20"
});
const Description = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "body04",
    color: "$black_06"
});
const SectionVideoPlayer = (param)=>{
    let { video , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: "RICH_TEXT_SM",
        children: [
            video && video.playbackId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .MuxPlayer */ .Ge, {
                playbackId: video.playbackId,
                poster: video.firstFrame,
                isAutoPlay: true,
                intersectionObserverOptions: {
                    rootMargin: "200px"
                }
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Description, {
                    children: [
                        "↑ ",
                        description
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 78432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ VideoTestimonial; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16405);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75762);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61349);
/* harmony import */ var _portfolio_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46115);






const hidingAnimation = {
    transition: "transform .7s, opacity .7s",
    variants: {
        hide: {
            true: {
                transform: "translateY(20px)",
                opacity: "0"
            },
            false: {
                transform: "translateY(0)",
                opacity: "1"
            }
        }
    }
};
const Slide = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    color: "$white",
    display: "grid",
    gap: "$32",
    gridTemplateRows: "max-content",
    alignItems: "center",
    cursor: "pointer",
    "-webkit-tap-highlight-color": "transparent",
    variants: {
        inView: {
            false: {
                pointerEvents: "none",
                cursor: "auto"
            }
        }
    }
});
const MediaWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    overflow: "hidden",
    borderRadius: "$r3_mobile",
    "@lg": {
        borderRadius: "$r3"
    },
    transform: "translateZ(0)",
    gridColumn: 1,
    gridRow: 1
});
const ContentWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    alignContent: "flex-end",
    gridColumn: 1,
    gridRow: 1,
    height: "100%",
    paddingBottom: "$32",
    gap: "$24",
    zIndex: "$content",
    overflow: "hidden",
    justifyContent: "center",
    justifyItems: "center",
    borderRadius: "calc($r3_mobile - 1px)",
    "@lg": {
        borderRadius: "calc($r3 - 1px)"
    },
    transform: "translateZ(0)",
    transition: "opacity .7s",
    background: "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))",
    variants: {
        hide: {
            true: {
                opacity: "0.75"
            },
            false: {
                opacity: "1"
            }
        }
    },
    "@md": {
        gap: "$32"
    }
});
const LogoWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    justifySelf: "center",
    maxWidth: 120,
    "@lg": {
        overflow: "hidden",
        height: 50,
        maxWidth: 180,
        width: "100%"
    },
    ...hidingAnimation
});
const TextWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
    ...hidingAnimation
});
const Name = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    projectFont: "body03",
    textAlign: "center"
});
const Position = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    projectFont: "body03",
    textAlign: "center",
    color: "$white_05"
});
const ControlButton = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
    display: "flex",
    margin: "0 auto",
    projectFont: "ui01",
    color: "$white",
    alignItems: "center",
    justifyContent: "center",
    gap: "$8",
    zIndex: "$content",
    "&:focus-visible": {
        outline: "$focusBlue solid 3px;"
    }
});
const VideoTestimonial = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { media , personName , personPosition , logo , play , canHideControlsForVideo , priority , handleOnEnded , handleSlidePlayPause , inView , sectionVideos  } = param;
    const isMd = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .ac)("md");
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("videoTestimonials");
    const hasMobileVideo = (media === null || media === void 0 ? void 0 : media.mediaPayload.type) === "mux-video" && media.mediaPayload.mobileVideo;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Slide, {
        onClickCapture: handleSlidePlayPause,
        ref: ref,
        children: [
            media && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaWrap, {
                children: (media === null || media === void 0 ? void 0 : media.mediaPayload.type) === "mux-video" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...media,
                    disablePlaceholderBackground: true,
                    hardcropRatio: "portrait2",
                    layout: "responsive",
                    videoOverride: (video)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Video */ .nk, {
                            alt: media === null || media === void 0 ? void 0 : media.alt,
                            firstFrame: video === null || video === void 0 ? void 0 : video.firstFrame,
                            width: video === null || video === void 0 ? void 0 : video.width,
                            height: video === null || video === void 0 ? void 0 : video.height,
                            muted: false,
                            loop: false,
                            src: video === null || video === void 0 ? void 0 : video.mp4,
                            play: hasMobileVideo ? play && inView && isMd : play && inView,
                            onEnded: handleOnEnded,
                            layout: "responsive",
                            priority: priority,
                            sizes: "(min-width: 1000px) 340px, (min-width: 740px) 300px, 224px"
                        });
                    },
                    videoOverrideMobile: (video)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Video */ .nk, {
                            alt: media === null || media === void 0 ? void 0 : media.alt,
                            firstFrame: video === null || video === void 0 ? void 0 : video.firstFrame,
                            width: video === null || video === void 0 ? void 0 : video.width,
                            height: video === null || video === void 0 ? void 0 : video.height,
                            muted: false,
                            loop: false,
                            src: video === null || video === void 0 ? void 0 : video.mp4,
                            play: hasMobileVideo ? play && inView && !isMd : play && inView,
                            onEnded: handleOnEnded,
                            layout: "responsive",
                            priority: priority,
                            sizes: "(min-width: 1000px) 340px, (min-width: 740px) 300px, 224px"
                        });
                    }
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...media,
                    hardcropRatio: "portrait2",
                    layout: "responsive",
                    sizes: "(min-width: 740px) 240px, (min-width: 1000px) 486px, 290px"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentWrap, {
                hide: canHideControlsForVideo,
                children: [
                    sectionVideos && isMd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrap, {
                        hide: canHideControlsForVideo,
                        children: logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                            ...logo,
                            disablePlaceholderBackground: true,
                            layout: "fill",
                            objectFit: "contain"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TextWrap, {
                        hide: canHideControlsForVideo,
                        children: [
                            personName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Name, {
                                children: personName
                            }),
                            personPosition && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Position, {
                                children: personPosition
                            })
                        ]
                    }),
                    !canHideControlsForVideo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ControlButton, {
                        children: [
                            t("play"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_icons__WEBPACK_IMPORTED_MODULE_5__/* .Play */ .sh, {})
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ControlButton, {
                        children: [
                            t("pause"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_icons__WEBPACK_IMPORTED_MODULE_5__/* .Pause */ .dz, {})
                        ]
                    })
                ]
            }),
            sectionVideos && !isMd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrap, {
                hide: canHideControlsForVideo && isMd,
                children: logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...logo,
                    disablePlaceholderBackground: true,
                    layout: "intrinsic"
                })
            })
        ]
    });
});


/***/ })

}]);